import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { observer } from 'mobx-react-lite';

import { ProductCardRect } from '../primitives/ProductCardRect';
import { getClientBrowser } from '@Utils/clientBrowser';

type Props = {
  gridCard: GridCard<PlaneTypes.Layout_HeroAndText_ImagePart>;
};

export const HeroAndTextImagePart = observer(function HeroAndTextImagePart({
  gridCard,
}: Props) {
  const { data } = gridCard;
  const cacheString = getClientBrowser() === 'Chrome' ? `?${Date.now()}` : '';

  if (data?.styles?.imagePart?.mediaType === 'image') {
    return (
      <group position={[0, gridCard.worldPosition.y, 0]}>
        <ProductCardRect
          size={data.styles!.imagePart!.imageSize}
          position={data.styles.imagePart.imagePosition}
          uniqueKey={gridCard.data!.key}
          imageUrl={data.dtoData.heroImageUrl + cacheString}
          hoverDisabled
          radius={0}
        />
      </group>
    );
  }

  return (
    <group position={[0, gridCard.worldPosition.y, 0]}>
      <mesh>
        <planeGeometry
          args={[
            data?.styles?.imagePart?.imageSize.width,
            data?.styles?.imagePart?.imageSize.height,
          ]}
        />
        <meshBasicMaterial color='blue' />
      </mesh>
    </group>
  );
});
